export default "__VITE_ASSET__A$SJUi3v__"